import { IExtendedSearch } from '..';
import { TESSearchFieldNames } from '../definitions';

import { THandlerState, TPlatformHandler } from './handlers';
import { handleCommonField } from './handlers/common';
import { handleMsField } from './handlers/ms';
import { handleParkinsonField } from './handlers/parkinson';
import { handleSleepApneaField } from './handlers/sleepApnea';
import { handleMgravisField } from './handlers/mgravis';
import { handleEpilepsyField } from './handlers/epilepsy';

// Create a pipeline of handlers to execute in order
const handlerPipeline: TPlatformHandler[] = [
  handleCommonField,
  handleMsField,
  handleParkinsonField,
  handleSleepApneaField,
  handleMgravisField,
  handleEpilepsyField,
];

const generateAdvancedSearchString = (
  fields: ('platform' | TESSearchFieldNames)[],
  state: IExtendedSearch['searchFields'] & {
    platform: IExtendedSearch['platform'];
    logicalOperators: IExtendedSearch['logicalOperators'];
  },
): string | undefined => {
  const handlerState: THandlerState = state;
  const searchStringFields: string[] = [];

  fields
    .filter(field => state[field] && state[field] !== 'noCropping')
    .forEach(field => {
      const thisDocumentFields: string[] = [];

      let query: string | undefined;

      // Try each handler in the pipeline
      for (const handler of handlerPipeline) {
        const result = handler(field, handlerState);
        if (result !== undefined) {
          // The first handler that returns a result claims the field
          query = result;
          break;
        }
      }

      // Fallback for simple fields not covered by any specific handler
      if (query === undefined && state[field] && state[field] !== 'noCropping') {
        if (!['age', 'gender', 'includeDeceased', 'diagnosis', 'diagnosisDate'].includes(field)) {
          query = `${field}@exists==TRUE`;
        }
      }

      if (query) {
        thisDocumentFields.push(query);
      }

      if (thisDocumentFields.length > 0) {
        searchStringFields.push(thisDocumentFields.join('&'));
      }
    });

  return searchStringFields.length > 0 ? searchStringFields.join('&') : undefined;
};

export default generateAdvancedSearchString;
